import React from "react"
import styled from "styled-components"

const CheckboxWrapper = styled.div`
    padding: 5px;
    span {
        padding-left: 10px;
    }
`

const BuildflowSpan = styled.span`
    color: #4ebed7;
    font-weight: bold;
`

const Checkbox = ({ label, isSelected, onCheckboxChange }) => (
    <CheckboxWrapper>
        <label>
            <input
                type="checkbox"
                name={label}
                checked={isSelected}
                onChange={onCheckboxChange}
                className="form-check-input"
            />
            {label === "buildflow" ? (
                <BuildflowSpan>{label}</BuildflowSpan>
            ) : (
                <span>{label}</span>
            )}
        </label>
    </CheckboxWrapper>
)

export default Checkbox



// WEBPACK FOOTER //
// ./src/OctoprintParser/Checkbox/index.js